import { motion } from 'framer-motion'
import { Lock } from 'lucide-react'
import Navbar from '../components/layout/Navbar'
import Footer from '../components/layout/Footer'
import { PrivacyPolicyBody } from './PrivacyPolicyBody'

export const PRIVACY_POLICY_LAST_UPDATED = 'May 2026'

function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar transparent />

      {/* ── Hero ─────────────────────────────────────────────────────────── */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-primary-50/60 via-white to-white" />
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-accent-500/8 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '2s' }} />

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-36 pb-16 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <div className="flex justify-center mb-5">
              <div className="flex items-center gap-2 badge-primary px-4 py-2">
                <Lock className="w-4 h-4" />
                <span className="text-sm font-semibold">Privacy Policy</span>
              </div>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
              How Rithmo{' '}
              <span className="gradient-text">Handles Your Data</span>
            </h1>

            <p className="text-gray-500 mb-6">Last updated: {PRIVACY_POLICY_LAST_UPDATED}</p>

            <div className="bg-amber-50 border border-amber-200 rounded-xl px-5 py-4 max-w-2xl mx-auto text-sm text-amber-900 leading-relaxed">
              Enterprise customers may also have order forms, data processing addenda, subprocessors,
              and security attachments. Contact{' '}
              <a href="mailto:legal@rithmo.ai" className="font-semibold underline">
                legal@rithmo.ai
              </a>{' '}
              for contractual materials.
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── Document Body ─────────────────────────────────────────────────── */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.article
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <PrivacyPolicyBody />
          </motion.article>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default PrivacyPage
